<template>
  <div class="container a3d trial">
    <div class="center">
      <img class="responsive-img center-align" src="/static/img/siemens_logo.png" />
    </div>
    <div class="row">
      <div class="col s12 center">
        <h5>AM Build Optimizer</h5>
      </div>
    </div>
    <div v-if="isShowForm">
      <h6 class="form-title center">FREE TRIAL REGISTRATION</h6>
      <div class="form-block">
        <div class="form-input">
          <div class="label">
            First Name
          </div>
          <input type="text" v-model="form.firstName.current" />
          <h6 class="error" v-if="form.firstName.invalid">Please enter your First Name</h6>
        </div>
        <div class="form-input">
          <div class="label">
            Last Name
          </div>
          <input type="text" v-model="form.lastName.current" />
          <h6 class="error" v-if="form.lastName.invalid">Please enter your Last Name</h6>
        </div>
        <div class="form-input">
          <div class="label">
            Email
          </div>
          <input type="text" v-model="form.email.current" />
          <h6 class="error" v-if="form.email.invalid">Please enter your email</h6>
        </div>
        <div class="col s12 center buttons-block">
          <div v-if="submitting" class='progress'>
            <div class='indeterminate'>
            </div>
          </div>
          <button v-else @click="submitForm" type="button" class="btn a3d">Sign Up</button>
        </div>
        <h6 v-if="error" class="error">Something went wrong</h6>
      </div>
      <div class="description">
        <ol>
          <li>
            The trial subscription will be active for 30 days.
          </li>
          <li>
            You will be asked to enter your email and create a password, you should use the same
            email and password you use for other Siemens sites you may have access to.
          </li>
          <li>
            You can submit optimizations from within NX-AM from the modeling perspective. You can
            also submit optimizations directly through the web-based user interface at
            <a href="https://portal.atlas3d.xyz">https://portal.atlas3d.xyz</a> or
            <a href="https://portal.atlas3dxyz.com">https://portal.atlas3dxyz.com</a>. Finally, you
            can also submit optimizations from within any NX installation you may have on your
            computer, provided it has been updated to version 1957 or later. Simply install the NX
            plugin by running the application called <strong>“Atlas3DtoNX.exe”</strong> available at
            <strong>C:\Program Files\Siemens\NX[Version Number]\MACH\auxiliary\mfgam</strong>. For
            either of these options, you must first complete the onboarding process for the AM Build
            Optimizer trial.
          </li>
        </ol>
      </div>
    </div>
    <div v-else-if="submitted" class="center">
      <h6 class="form-title">An invitation to AM Build Optimizer has been sent to your email.</h6>
    </div>
    <div class="row" v-else>
      <div class="col s12 center buttons-block">
        <button @click="showForm" type="button" class="btn a3d">Start Free Trial</button>
        <a :href="loginHost" class="btn a3d inv">Log in</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Trial',
  computed: {
    ...mapState(['auth']),
    loginHost () {
      return `https://${window.location.hostname.replace('trials', 'portal')}/splash?login=true`
    }
  },
  data () {
    return {
      isShowForm: false,
      form: {
        firstName: {last: '', current: '', invalid: false},
        lastName: {last: '', current: '', invalid: false},
        email: {last: '', current: '', invalid: false}
      },
      submitting: false,
      submitted: false,
      error: null
    }
  },
  methods: {
    ...mapActions(['submitTrialForm']),
    showForm () {
      this.isShowForm = true
    },
    verifyString (sString, length) {
      if (sString.current.length < length) {
        sString.current = sString.last
        sString.invalid = true
        return false
      } else {
        sString.last = sString.current
        sString.invalid = false
        return true
      }
    },
    isFormValid () {
      return this.verifyString(this.form.firstName, 2) &&
        this.verifyString(this.form.lastName, 2) &&
        this.verifyString(this.form.email, 2)
    },
    submitForm () {
      if (!this.isFormValid()) {
        return
      }
      this.submitting = true

      this.submitTrialForm({
        firstName: this.form.firstName.current,
        lastName: this.form.lastName.current,
        email: this.form.email.current
      })
        .then(() => {
          this.submitting = false
          this.isShowForm = false
          this.submitted = true
        })
        .catch((e) => {
          this.error = true
          this.submitting = false
          console.log(e)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.trial {
  padding-top: 5%;

  .responsive-img {
    max-width: 400px;
    margin: 0 30px;
  }

  .form-block, .description {
    min-width: 400px;
  }

  .description {
    max-width: 80%;
    margin: 0 auto;

    strong {
      font-weight: 600;
    }
  }

  .form-title {
    font-size: 1.1rem;
  }

  .form-block {
    max-width: 50%;
    background-color: #F2F2F2;
    padding: 15px;
    margin: 15px auto 30px;

    .label {
      padding: 4px 0;
    }

    input {
      background-color: #FFFFFF;
    }
  }

  .buttons-block button {
    margin: 0 2px;
  }

  .error { 
    color: #FF0000;
  }
}
</style>



// WEBPACK FOOTER //
// Trial.vue?ea10a8a4